import { selectBuildingConstructionInProgress } from "../../../selectors/selectBuildingConstructionInProgress";
import { createPathSelectBuilding } from "./createPathSelectBuilding";
export var pathSelectBuildingConstructionInProgress = function (action, state$, deps) {
    return createPathSelectBuilding(function () {
        var state = state$.value;
        return selectBuildingConstructionInProgress(state);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectBuildingConstructionInProgress.ts
// module id = 904
// module chunks = 3